import { ReactNode } from 'react'

/**
 * Wrapper for the dashboard's charts. Unlike the shared ChartFrame it does not clip overflow, so a
 * tooltip near the edge of a card is not cut off; the chart itself is still held to its container
 * width, and tooltip text wraps instead of running out of the chart.
 */
export function LiveChartFrame({ children }: { children: ReactNode }) {
  return (
    <div
      className='live-chart w-100'
      style={{ minWidth: 0, maxWidth: '100%', position: 'relative' }}
    >
      {children}
      <style>{`
        .live-chart .apexcharts-canvas { max-width: 100% !important; }
        .live-chart .apexcharts-svg { max-width: 100%; }
        .live-chart .apexcharts-legend { max-width: 100%; padding: 0 4px !important; }
        .live-chart .apexcharts-tooltip.apexcharts-active {
          background: transparent !important;
          border: 0 !important;
          box-shadow: none !important;
          overflow: visible !important;
          z-index: 20;
        }
        .live-chart .live-tip {
          min-width: 150px;
          max-width: 260px;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 12px;
          line-height: 1.45;
          white-space: normal;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        }
        .live-chart .live-tip-title { font-weight: 600; padding-bottom: 4px; margin-bottom: 4px; }
        .live-chart .live-tip-row { display: flex; align-items: baseline; gap: 6px; }
        .live-chart .live-tip-label { flex: 1 1 auto; }
        .live-chart .live-tip-value { font-weight: 600; white-space: nowrap; }
        .live-chart .live-tip-dot { width: 8px; height: 8px; border-radius: 50%; flex: 0 0 8px; align-self: center; }
        .live-chart .live-tip-note { margin-top: 4px; font-size: 11px; }
      `}</style>
    </div>
  )
}
